import { render, staticRenderFns } from "./oa-planning-review.vue?vue&type=template&id=86be979a&scoped=true"
import script from "./oa-planning-review.vue?vue&type=script&lang=js"
export * from "./oa-planning-review.vue?vue&type=script&lang=js"
import style0 from "./oa-planning-review.vue?vue&type=style&index=0&id=86be979a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86be979a",
  null
  
)

export default component.exports